"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = void 0;
const Check_svg_1 = __importDefault(require("./71eb904/assets/circle/Check.svg"));
const Ellipses_svg_1 = __importDefault(require("./71eb904/assets/circle/Ellipses.svg"));
const EllipsesLoading_svg_1 = __importDefault(require("./71eb904/assets/circle/EllipsesLoading.svg"));
const Exclamation_svg_1 = __importDefault(require("./71eb904/assets/circle/Exclamation.svg"));
const Padlock_svg_1 = __importDefault(require("./71eb904/assets/circle/Padlock.svg"));
const Question_svg_1 = __importDefault(require("./71eb904/assets/circle/Question.svg"));
const Star_svg_1 = __importDefault(require("./71eb904/assets/circle/Star.svg"));
const Down_svg_1 = __importDefault(require("./71eb904/assets/direction/Down.svg"));
const Left_svg_1 = __importDefault(require("./71eb904/assets/direction/Left.svg"));
const Right_svg_1 = __importDefault(require("./71eb904/assets/direction/Right.svg"));
const Up_svg_1 = __importDefault(require("./71eb904/assets/direction/Up.svg"));
const Minus_svg_1 = __importDefault(require("./71eb904/assets/math/Minus.svg"));
const Plus_svg_1 = __importDefault(require("./71eb904/assets/math/Plus.svg"));
const Cog_svg_1 = __importDefault(require("./71eb904/assets/misc/Cog.svg"));
const Ellipses_svg_2 = __importDefault(require("./71eb904/assets/misc/Ellipses.svg"));
const Exclamation_svg_2 = __importDefault(require("./71eb904/assets/misc/Exclamation.svg"));
const External_svg_1 = __importDefault(require("./71eb904/assets/misc/External.svg"));
const Fullscreen_svg_1 = __importDefault(require("./71eb904/assets/misc/Fullscreen.svg"));
const Hamburger_svg_1 = __importDefault(require("./71eb904/assets/misc/Hamburger.svg"));
const Locked_svg_1 = __importDefault(require("./71eb904/assets/misc/Locked.svg"));
const Question_svg_2 = __importDefault(require("./71eb904/assets/misc/Question.svg"));
const Search_svg_1 = __importDefault(require("./71eb904/assets/misc/Search.svg"));
const Star_svg_2 = __importDefault(require("./71eb904/assets/misc/Star.svg"));
const Trash_svg_1 = __importDefault(require("./71eb904/assets/misc/Trash.svg"));
const Check_svg_2 = __importDefault(require("./71eb904/assets/validation/Check.svg"));
const Cross_svg_1 = __importDefault(require("./71eb904/assets/validation/Cross.svg"));
exports.Icons = {
    circleCheck: Check_svg_1.default,
    circleEllipses: Ellipses_svg_1.default,
    circleEllipsesLoading: EllipsesLoading_svg_1.default,
    circleExclamation: Exclamation_svg_1.default,
    circlePadlock: Padlock_svg_1.default,
    circleQuestion: Question_svg_1.default,
    circleStar: Star_svg_1.default,
    up: Up_svg_1.default,
    down: Down_svg_1.default,
    left: Left_svg_1.default,
    right: Right_svg_1.default,
    plus: Plus_svg_1.default,
    minus: Minus_svg_1.default,
    cog: Cog_svg_1.default,
    ellipses: Ellipses_svg_2.default,
    exclamation: Exclamation_svg_2.default,
    fullscreen: Fullscreen_svg_1.default,
    hamburger: Hamburger_svg_1.default,
    locked: Locked_svg_1.default,
    question: Question_svg_2.default,
    search: Search_svg_1.default,
    star: Star_svg_2.default,
    trash: Trash_svg_1.default,
    check: Check_svg_2.default,
    cross: Cross_svg_1.default,
    external: External_svg_1.default
};
//# sourceMappingURL=icons.js.map